<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>
                    <div class="container-fluid">
                        <p>Help works !</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
